import { FaGlobe, FaDatabase, FaBolt, FaShieldAlt } from "react-icons/fa";

const Stats = () => (
  <section className="relative bg-gradient-to-b from-[#161c3a] to-[#0f172a] text-white py-24 px-6 text-center overflow-hidden rounded-b-3xl">
    {/* 背景光斑 */}
    <div className="absolute w-[700px] h-[700px] bg-indigo-500 opacity-20 rounded-full blur-3xl top-[-200px] left-[-100px] z-0"></div>

    <h2 className="text-4xl font-bold mb-16 relative z-10 tracking-wide">服务数据</h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 max-w-6xl mx-auto relative z-10">
      {[
        { icon: <FaGlobe />, title: "全球节点", value: "30+" },
        { icon: <FaDatabase />, title: "日均解析次数", value: "5千万+" },
        { icon: <FaBolt />, title: "活跃域名", value: "1500+" },
        { icon: <FaShieldAlt />, title: "SLA 保障", value: "99.99%" },
      ].map((item, index) => (
        <div
          key={index}
          className="bg-gray-700/60 rounded-xl px-8 py-10 flex flex-col items-center border border-indigo-500/20 hover:scale-105 transition-transform duration-300"
        >
          <div className="w-12 h-12 rounded-full bg-indigo-600/20 flex items-center justify-center text-indigo-400 text-xl mb-4">
            {item.icon}
          </div>
          <div className="text-4xl font-extrabold text-indigo-400 tracking-wide">{item.value}</div>
          <div className="mt-2 text-gray-200 text-sm tracking-wider">{item.title}</div>
        </div>
      ))}
    </div>
  </section>
);

export default Stats;